import { ClassNameProps, Item } from '../../types/types';
import { listConectItems } from '../../data/data';
import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

const ListConect: React.FC<ClassNameProps> = ({ className }) => {
  const ref = useRef<HTMLUListElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const handleScroll = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const elemTop = rect.top;
      const elemBottom = rect.bottom;
      const isVisible = elemTop < window.innerHeight && elemBottom >= 0;
      setIsVisible(isVisible);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <section className={className}>
      <div className={`${className}__container`}>
        <ul className={`${className}-connect`} ref={ref}>
          {listConectItems.map((item: Item, index: number) => (
            <motion.li
              key={item.id}
              className={className + '-connect__item card'}
              initial={{ x: -2000 }}
              animate={{ x: isVisible ? 0 : -2000 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
            >
              <img
                src={item.img}
                className={`${className}-connect__img`}
                alt={item.title}
              />
              <span className={className + '-connect__text text-small'}>
                {item.text}
              </span>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
};
export default ListConect;
